<template>
  <section>
    <nav-component
      :titulo="'Empleados en nomina'"
      :link="{ path: '/formulario-nomina' }"
      :texto="'Registrar Empleado'"
    />
    <b-table
      class="box"
      :data="nomina"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      default-sort="fecha"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="cedula"
        label="Cedula"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.cedula }}
      </b-table-column>

      <b-table-column
        field="nombre"
        label="Nombre"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.nombre }}
      </b-table-column>

      <b-table-column
        field="eps"
        label="Eps"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.eps }}
      </b-table-column>

      <b-table-column
        field="fecha_nacimiento"
        label="Cumpleaños"
        sortable
        searchable
        v-slot="props"
      >
        {{ getCumpleaños(props.row.fecha_nacimiento) }}
      </b-table-column>

      <b-table-column
        field="contacto"
        label="Contacto"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.contacto }}
      </b-table-column>

      <b-table-column
        field="contacto_emergencia"
        label="Contacto Emergencia"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.contacto_emergencia }}
      </b-table-column>

      <b-table-column
        field="tipo_sangre"
        label="Rh "
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.tipo_sangre }}
      </b-table-column>

      <b-table-column field="eliminar" label="Eliminar" v-slot="props">
        <b-button
          type="is-danger"
          icon-left="delete"
          @click="eliminar(props.row.id, props.row.nombre)"
        ></b-button>
      </b-table-column>

      <b-table-column field="editar" label="Editar" v-slot="props">
        <b-button
          type="is-info"
          icon-left="pencil"
          @click="editar(props.row.id)"
        ></b-button>
      </b-table-column>
    </b-table>
</section>
</template>
  
  <script>
import Swal from "sweetalert2";
import HttpService from "../../Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";
import NavComponent from "../Extras/NavComponent";

export default {
    mixins: [NotificacionesMixin],
    components: { NavComponent },

  data: () => ({
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "desc", // Cambiado a "desc" para ordenar de manera descendente
    sortIcon: "arrow-up",
    sortIconSize: "is-medium",
    currentPage: 1,
    perPage: 20,
    transacciones: [],
    nomina: [],
  }),

  mounted() {
    this.obtenerNomina();
  },

  methods: {
    //   calcularTotal(tipo) {
    //     return this.transacciones
    //       .filter((t) => t.tipo === tipo)
    //       .reduce((total, t) => total + parseInt(t.valor), 0)
    //       .toLocaleString("es-CO");
    //   },
    //   onBusquedaEnFecha(fechas) {
    //     // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
    //     const fechaInicio = new Date(fechas[0]);
    //     fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
    //     // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
    //     const fechaInicioString =
    //       fechaInicio.toISOString().split("T")[0] + " 05:00:00";
    //     this.filtros.fechaInicio = fechaInicioString;
    //     // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
    //     const fechaFin = new Date(fechas[1]);
    //     fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
    //     // Sumar un día a la fecha fin
    //     fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
    //     // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
    //     const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
    //     this.filtros.fechaFin = fechaFinString;
    //     this.obtenerTransacciones();
    //   },

    getCumpleaños(fechaNacimiento) {
      const [year, month, day] = fechaNacimiento.split("-");
      console.log(year);
      const currentYear = new Date().getFullYear();

      // Crear una nueva fecha de cumpleaños con el año actual
      const birthdayThisYear = new Date(
        currentYear,
        parseInt(month) - 1,
        parseInt(day)
      );

      // Formatear la fecha de cumpleaños
      return birthdayThisYear.toLocaleDateString("es-ES", {
        month: "long",
        day: "numeric",
      });
    },
    obtenerNomina() {
      let payload = {
        accion: "obtenerNomina",
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (transacciones) => {
          this.nomina = transacciones;
        }
      );
    },
    eliminar(id, nombre) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto! Se eliminarán todo lo relacionado de " + nombre,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminarlo",
      }).then((result) => {
        if (result.isConfirmed) {
          HttpService.eliminar("reportes.php", {
            accion: "eliminarEmpleadoNomina",
            id: id,
          }).then((resultado) => {
            if (!resultado) {
              this.mostrarNotificacion('error', "Error al eliminar");
              this.cargando = false;
              return;
            }
            this.mostrarNotificacion('success', "Empleado eliminado");
            this.cargando = false;
            this.obtenerNomina();
          }).catch(() => {
            this.mostrarNotificacion('error', "Error al eliminar");
            this.cargando = false;
          });
        }
      });
    },
    editar(id) {
      this.$router.push({
        name: "FormularioNominaEditar",
        params: { id: id },
      });
    },
  },
};
</script>
  
  